import { Loading, Icon } from 'JBSrc/constants';
import { scrollTo } from 'JBPlugin/scroll-to';

class EventTypeCheck {
	constructor(){
		this.general_min = 1;
		this.eventFormClass = '.event-start-form';
		this.startButton = '#startEvent';
		this.eventTypeModal = '#eventTypeModal';
		this.resetButton = '.resetEventType';
		this.eventDescriptionClass = '.event-type-description';
	}

	initTriggers(){
		let self = this;
		$(document).on('click', '.setEventType', function(e){
			e.preventDefault();
			let button = $(this);
			$(button.data('field')).val(button.data('value'));
			$('.event-start-form .tab-pane.active').removeClass('active').removeClass('show');
			$('#tab-' + button.data('value')).tab('show');
			$(self.resetButton).removeClass('d-none');
			$(self.startButton).removeClass('d-none');
			scrollTo('#eventStartTop');
			self.statusCheck();
		});

		$(document).on('click', self.resetButton, function(e){
			e.preventDefault();
			$('#eventType').val('');
			$('.event-start-form .tab-pane.active').removeClass('active').removeClass('show');
			$(self.startButton).attr('disabled', true).addClass('disabled d-none');
			$('#tab-type').tab('show');
			$(self.resetButton).addClass('d-none');
			scrollTo('#eventStartTop');
		});

		$(document).on('change', self.eventFormClass + ' input', function(){
			$(self.startButton).removeClass('d-none');
			self.statusCheck();
		});
	}

	statusCheck(){
		let self = this, buttonText = '';

		$('.radio-show-hide').each(function(){
			let radioField = $(this);
			if($(radioField.data('field') + ':checked').val() == radioField.data('value')){
				radioField.removeClass('hidden');
			}else{
				radioField.addClass('hidden');
			}
		});

		buttonText = $(self.startButton).text();
		$(self.startButton).html(Loading.icon + buttonText);
		$.post('/events/startcheck', $(self.eventFormClass).serialize(), function(data){
			if(data.canProgress){
				$(self.startButton).removeAttr('disabled').removeClass('disabled d-none');

				if($(self.eventDescriptionClass + '[data-type="' + data.confirmedEventType + '"]').length){
					$(self.eventTypeModal).find('.modal-inner').html($(self.eventDescriptionClass + '[data-type="' + data.confirmedEventType + '"]').html());
					if(!($(self.eventTypeModal).data('bs.modal') || {})._isShown){
						$(self.eventTypeModal).modal('show');
					}
				}
			}else{
				$(self.startButton).attr('disabled', true).addClass('disabled d-none');
			}
			$(self.startButton).find('.loading-icon').remove();
		},'json').fail(function(){
			$(self.startButton).find('.loading-icon').remove();
		});
	}
}
(function($) {
	const eventTypeCheck = new EventTypeCheck;
	eventTypeCheck.initTriggers();
})(jQuery);
